import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Products & cart now come from Shopify (headless Storefront API) via the backend
export const getProducts = () => api.get("/shop/products").then((r) => r.data);
export const getProduct = (slug) => api.get(`/shop/products/${slug}`).then((r) => r.data);

export const createShopifyCheckout = (items) =>
  api.post("/shop/cart", { items }).then((r) => r.data);

export const notifyDrop = (email, hp = "") => api.post("/notify", { email, hp }).then((r) => r.data);

export const fmt = (n) => `${Number.isInteger(n) ? n : n.toFixed(2)} zł`;
